export const environment = {
  firebase: {
    projectId: 'wickedinfinitypublishing',
    appId: '1:1062089860397:web:66c63167c9f1d551429fa4',
    storageBucket: 'wickedinfinitypublishing.appspot.com',
    locationId: 'us-central',
    apiKey: 'AIzaSyB-UdPY2Yh6o_tRYOxJ46M6Ie2PEyGdj6c',
    authDomain: 'wickedinfinitypublishing.firebaseapp.com',
    messagingSenderId: '1062089860397',
    measurementId: 'G-RWMKM41GTV',
  },
  url: 'localhost:4200',
  production: false
};